import * as React from 'react';

import { Link } from '@coursera/cds-core';

import { CourseraMetatags } from 'bundles/seo';

import _t from 'i18n!nls/about';

export default function CookiesTablePage() {
  return (
    <div className="rc-CookiesTablePage">
      <CourseraMetatags metaNameAndProperties={{ title: 'Cookies Table' }} />

      <div className="coursera-cookies-table coursera-about-title-heading">
        <h1 data-section="cookiesTable">{_t('Cookies Table')}</h1>
        <hr className="header-after" />
        <div className="coursera-tos-text">
          <p>
            {_t(
              'The tables below list some of the internal and third-party cookies we use. As the names, numbers, and purposes of these cookies may change over time, this page may be updated to reflect those changes. For more information on how we use these cookies, please refer to our '
            )}
            <Link href="/about/cookies">{_t('Cookies Policy')}</Link>.
          </p>
          <h2>{_t('Coursera Cookies:')}</h2>
          <div className="responsive-table-wrapper">
            <table className="cookies-table">
              <tbody>
                <tr>
                  <th>{_t('Host Name')}</th>
                  <th>{_t('Cookie Name')}</th>
                  <th>{_t('Purpose')}</th>
                  <th>{_t('Expiration')}</th>
                  <th>{_t('More information')}</th>
                </tr>
                <tr>
                  {/* @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type 'number | ... Remove this comment to see the full error message */}
                  <td rowSpan="7">Coursera</td>
                  <td>CAUTH/CAUTHDEV</td>
                  <td>{_t('Essential')}</td>
                  <td>{_t('50 days')}</td>
                  {/* @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type 'number | ... Remove this comment to see the full error message */}
                  <td rowSpan="7">
                    <Link href="/about/cookies">{_t('Coursera Cookies Policy')}</Link>
                  </td>
                </tr>
                <tr>
                  <td>CSRF3-Token</td>
                  <td>{_t('Essential')}</td>
                  <td>{_t('2 weeks')}</td>
                </tr>
                <tr>
                  <td>_utma / _utmc / _ga / _gid</td>
                  <td>{_t('Targeting')}</td>
                  <td>{_t('Varies')}</td>
                </tr>
                <tr>
                  <td>_204r / _204u / _400v / _400t</td>
                  <td>{_t('Analytical/performance')}</td>
                  <td>{_t('Varies')}</td>
                </tr>
                <tr>
                  <td>ip_currency</td>
                  <td>{_t('Functionality')}</td>
                  <td>{_t('1 day')}</td>
                </tr>
                <tr>
                  <td>ip_origin</td>
                  <td>{_t('Functionality')}</td>
                  <td>{_t('1 day')}</td>
                </tr>
                <tr>
                  <td>lux_uid</td>
                  <td>{_t('Essential')}</td>
                  <td>{_t('30 minutes')}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <h2>{_t('Third-Party Cookies:')}</h2>
          <div className="responsive-table-wrapper">
            <table className="cookies-table">
              <tbody>
                <tr>
                  <th>{_t('Host Name')}</th>
                  <th>{_t('Cookie Name')}</th>
                  <th>{_t('Purpose')}</th>
                  <th>{_t('Expiration')}</th>
                  <th>{_t('More information')}</th>
                </tr>
                <tr>
                  {/* @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type 'number | ... Remove this comment to see the full error message */}
                  <td rowSpan="3">AirPR</td>
                  <td>an_airpr_recent_visit</td>
                  <td>{_t('Tracking')}</td>
                  <td>{_t('15 minutes')}</td>
                  <td>
                    <Link href="https://airpr.com/privacy-policy/">AirPR Privacy Policy</Link>
                  </td>
                </tr>
                <tr>
                  <td>sess</td>
                  <td>{_t('Tracking')}</td>
                  <td>{_t('1 day')}</td>
                  {/* @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type 'number | ... Remove this comment to see the full error message */}
                  <td rowSpan="2">
                    <Link href="https://www.appnexus.com/en/company/platform-privacy-policy">
                      {_t('App Nexus Opt-Out')}
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td>uuid2</td>
                  <td>{_t('Tracking')}</td>
                  <td>{_t('3 months')}</td>
                </tr>
                <tr>
                  {/* @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type 'number | ... Remove this comment to see the full error message */}
                  <td colSpan="5" />
                </tr>
                <tr>
                  <td>Bing</td>
                  <td>MUID</td>
                  <td>{_t('Optimization')}</td>
                  <td>1{_t('3 months')}</td>
                  <td>
                    <Link href="https://privacy.microsoft.com/en-us/privacystatement">
                      {_t('Microsoft Privacy Statement')}
                    </Link>
                  </td>
                </tr>
                <tr>
                  {/* @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type 'number | ... Remove this comment to see the full error message */}
                  <td colSpan="5" />
                </tr>
                <tr>
                  <td>dc-storm (Rakuten)</td>
                  <td>_#pid</td>
                  <td>{_t('Optimization')}</td>
                  <td>{_t('3 months')}</td>
                  <td>
                    <Link href="https://rakutenmarketing.com/legal-notices/ad-choice-preferences">
                      {_t('Rakuten Opt-Out')}
                    </Link>
                  </td>
                </tr>
                <tr>
                  {/* @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type 'number | ... Remove this comment to see the full error message */}
                  <td colSpan="5" />
                </tr>
                <tr>
                  <td>DoubleClick</td>
                  <td>id</td>
                  <td>{_t('Partner')}</td>
                  <td>{_t('20 months')}</td>
                  <td>
                    <Link href="https://support.google.com/dfp_premium/answer/2839090?hl=en">
                      {_t('DoubleClick Cookies Policy')}
                    </Link>
                  </td>
                </tr>
                <tr>
                  {/* @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type 'number | ... Remove this comment to see the full error message */}
                  <td colSpan="5" />
                </tr>
                <tr>
                  {/* @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type 'number | ... Remove this comment to see the full error message */}
                  <td rowSpan="3">Facebook</td>
                  <td>fr</td>
                  <td>{_t('Optimization')}</td>
                  <td>{_t('3 months')}</td>
                  {/* @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type 'number | ... Remove this comment to see the full error message */}
                  <td rowSpan="3">
                    <Link href="https://www.facebook.com/policies/cookies/">{_t('Facebook Cookies Policy')}</Link>
                  </td>
                </tr>
                <tr>
                  <td>lu</td>
                  <td>{_t('Optimization')}</td>
                  <td>{_t('20 months')}</td>
                </tr>
                <tr>
                  <td>_fbp</td>
                  <td>{_t('Targeting')}</td>
                  <td>{_t('90 days')}</td>
                </tr>
                <tr>
                  {/* @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type 'number | ... Remove this comment to see the full error message */}
                  <td colSpan="5" />
                </tr>
                <tr>
                  {/* @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type 'number | ... Remove this comment to see the full error message */}
                  <td rowSpan="2">Google</td>
                  <td>HSID</td>
                  <td>{_t('Tracking, Optimization, Partner')}</td>
                  <td>{_t('20 months')}</td>
                  {/* @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type 'number | ... Remove this comment to see the full error message */}
                  <td rowSpan="2">
                    <Link href="https://www.google.com/policies/technologies/managing/">{_t('Google Opt-Out')}</Link>
                  </td>
                </tr>
                <tr>
                  <td>PREF</td>
                  <td>{_t('Tracking, Optimization, Partner')}</td>
                  <td>{_t('20 months')}</td>
                </tr>
                <tr>
                  {/* @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type 'number | ... Remove this comment to see the full error message */}
                  <td colSpan="5" />
                </tr>
                <tr>
                  {/* @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type 'number | ... Remove this comment to see the full error message */}
                  <td rowSpan="4">LinkSynergy (Rakuten)</td>
                  <td>rmuid</td>
                  <td>{_t('Optimization')}</td>
                  <td>{_t('1 year')}</td>
                  {/* @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type 'number | ... Remove this comment to see the full error message */}
                  <td rowSpan="2">
                    <Link href="https://rakutenmarketing.com/legal-notices/ad-choice-preferences">
                      {_t('Rakuten Opt-Out')}
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td>icts</td>
                  <td>{_t('Optimization')}</td>
                  <td>{_t('1 year')}</td>
                </tr>
                <tr>
                  <td>rlas3</td>
                  <td>{_t('Tracking')}</td>
                  <td>{_t('6 months')}</td>
                  {/* @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type 'number | ... Remove this comment to see the full error message */}
                  <td rowSpan="2">
                    <Link href="https://liveramp.com/opt_out/">{_t('LiveRamp Opt-Out')}</Link>
                  </td>
                </tr>
                <tr>
                  <td>ck1</td>
                  <td>{_t('Tracking')}</td>
                  <td>{_t('6 months')}</td>
                </tr>
                <tr>
                  {/* @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type 'number | ... Remove this comment to see the full error message */}
                  <td colSpan="5" />
                </tr>
                <tr>
                  <td>Marketo</td>
                  <td>BIGipServerabrtp1_https</td>
                  <td>{_t('Tracking')}</td>
                  <td>{_t('7 minutes')}</td>
                  <td>
                    <Link href="https://documents.marketo.com/legal/cookies/">{_t('Marketo Cookies Policy')}</Link>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
